import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import { __decorate } from "tslib";
import { Vue, Options } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
var UserCell = /*#__PURE__*/function (_Vue) {
  function UserCell() {
    var _this;
    _classCallCheck(this, UserCell);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, UserCell, [].concat(args));
    _defineProperty(_this, "image", void 0);
    _defineProperty(_this, "firstName", void 0);
    _defineProperty(_this, "lastName", void 0);
    _defineProperty(_this, "email", void 0);
    return _this;
  }
  _inherits(UserCell, _Vue);
  return _createClass(UserCell);
}(Vue);
__decorate([Prop({
  default: ""
})], UserCell.prototype, "image", void 0);
__decorate([Prop({
  default: ""
})], UserCell.prototype, "firstName", void 0);
__decorate([Prop({
  default: ""
})], UserCell.prototype, "lastName", void 0);
__decorate([Prop({
  default: ""
})], UserCell.prototype, "email", void 0);
UserCell = __decorate([Options({
  components: {}
})], UserCell);
export default UserCell;